import { normalizeUser, type User } from '@/data'
import api from '.'

export interface UserPayload {
  name: string
  email: string
  password: string
  partner_ids?: number[]
  role_ids?: number[]
  permission_ids?: number[]
}

export async function createUser(payload: UserPayload): Promise<User> {
  const res = await api.post('/', payload)
  return normalizeUser(res.data.data)
}
